import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import './index.scss';
import styles from './index.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import InputContextMenu from '@web-common/components/UI/InputContextMenu/InputContextMenu';
import LxInput from '@lingxi-common-component/sirius-ui/Input';
const ContentSearch = props => {
    const { searchContent, closeSearch, index, count, searchInputVisible, setSearchInputVisible, keyword, setKeyword } = props;
    const inputRef = useRef(null);
    const [afterFirstSearch, setAfterFirstSearch] = useState(false);
    useEffect(() => {
        if (!searchInputVisible) {
            setKeyword('');
        }
        if (searchInputVisible && inputRef.current) {
            inputRef.current.input.focus();
        }
    }, [searchInputVisible]);
    const nextPrev = useCallback((type) => {
        if (type === 'next') {
            searchContent(keyword);
            return;
        }
        searchContent(keyword, false);
    }, [searchContent, keyword]);
    const searchOperate = useMemo(() => {
        return (React.createElement("div", { className: styles.operate },
            count > 0 && (React.createElement(React.Fragment, null,
                React.createElement(IconCard, { type: "arrowLeft", className: `dark-invert ${styles.nextPrev}`, onClick: () => {
                        nextPrev('prev');
                    } }),
                React.createElement("span", null,
                    index + 1,
                    "/",
                    count),
                React.createElement(IconCard, { type: "arrowRight", opcacity: "1", className: `dark-invert ${styles.nextPrev}`, onClick: () => {
                        nextPrev('next');
                    } }))),
            count === 0 && afterFirstSearch && '没有结果'));
    }, [index, count, nextPrev, afterFirstSearch]);
    useEffect(() => {
        if (index === -1) {
            setAfterFirstSearch(false);
        }
    }, [index]);
    const closeSearchFn = () => {
        closeSearch && closeSearch();
        searchContent('');
        setKeyword('');
        setSearchInputVisible(false);
        setAfterFirstSearch(false);
    };
    return (React.createElement("div", { className: classnames(styles.wrapper), hidden: !searchInputVisible },
        React.createElement(InputContextMenu, { inputOutRef: inputRef },
            React.createElement(LxInput, { className: styles.searchInput, onChange: e => {
                    setKeyword(String(e.target.value));
                }, ref: inputRef, value: keyword, placeholder: "\u8F93\u5165\u6B63\u6587\u5173\u952E\u5B57\u6309\u56DE\u8F66\u8FDB\u884C\u641C\u7D22", onKeyDown: e => {
                    if (e.key === 'Enter') {
                        searchContent(keyword);
                        setAfterFirstSearch(true);
                    }
                }, suffix: searchOperate, style: { height: '28px' } })),
        React.createElement("div", { className: classnames(styles.close), "data-test-id": "content-search-close-button", onClick: closeSearchFn },
            React.createElement(IconCard, { type: "close" }))));
};
export default ContentSearch;
